import { render, staticRenderFns } from "./FinanceBase.vue?vue&type=template&id=6fcb65c6&"
import script from "./FinanceBase.vue?vue&type=script&lang=ts&"
export * from "./FinanceBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports